import { isWithinInterval } from 'date-fns/isWithinInterval';
import { endOfMonth, startOfMonth, addDays, addMonths, format, startOfDay, endOfDay } from 'date-fns';
import type { ServiceMethodParamCalendar } from '../services/CarrierService/types';
export type ServiceMethodConfigurationStatus = 'complete' | 'incomplete' | 'danger' | 'empty';
// function to check whether a month is completely covered by service
// method param calendar
// date can be any date within the month you want to check
export const monthCompletlyCovered = (date: Date, covered: ServiceMethodParamCalendar[]): boolean => {
  // smash time intervals together if overlapping or touching
  const dateObj = date;
  covered = [...covered];
  const combindedIntervals = covered
    ?.sort((a: any, b: any) => a.startDateTime - b.startDateTime)
    ?.reduce((last: any[], val: any) => {
      if (
        !last.length ||
        // reduce deals with case when 2 param calendars cover a single month
        // if calendars bumps against each other
        // (endDateTime within one day of startDateTime) we consider intervals connected
        addDays(new Date(last[last.length - 1].endDateTime), 1) < new Date(val.startDateTime)
      ) {
        last.push({ ...val });
      } else {
        last[last.length - 1].endDateTime = val.endDateTime;
      }
      return last;
    }, []);
  // if there is combinded service method that contains the entirety of the month
  // the month is covered
  for (let i = 0; i < combindedIntervals?.length; i++) {
    const interval = combindedIntervals[i];
    const startWithin = isWithinInterval(endOfDay(startOfMonth(dateObj)), {
      start: new Date(interval.startDateTime),
      end: new Date(interval.endDateTime),
    });
    const endWithin = isWithinInterval(startOfDay(endOfMonth(dateObj)), {
      start: new Date(interval.startDateTime),
      end: new Date(interval.endDateTime),
    });
    if (startWithin && endWithin) {
      return true;
    }
  }
  return false;
};

// creates a map of month string to param calendars that apply to that month
export const getMonthsCovered = (
  paramCalendar: ServiceMethodParamCalendar[],
): Record<string, [ServiceMethodParamCalendar]> => {
  const coveredMonths: Record<string, [ServiceMethodParamCalendar]> = {};
  paramCalendar.map((val) => {
    let dateI = new Date(val.startDateTime);
    const endDate = new Date(val.endDateTime);
    while (dateI <= endDate) {
      const curr = format(dateI, 'MM/yyyy');
      coveredMonths[curr] ? coveredMonths[curr].push(val) : (coveredMonths[curr] = [val]);
      dateI = addMonths(dateI, 1);
    }
    return dateI;
  });
  return coveredMonths;
};

// gets the param calendar that covers  the given data (if it exists)
export const getDatesCovered = (
  paramCalendar: ServiceMethodParamCalendar[],
): Record<string, ServiceMethodParamCalendar> => {
  const coveredDates: Record<string, ServiceMethodParamCalendar> = {};
  paramCalendar.map((val) => {
    let dateI = new Date(val.startDateTime);
    const endDate = new Date(val.endDateTime);
    while (dateI <= endDate) {
      const curr = format(dateI, 'MM/dd/yyyy');
      coveredDates[curr] = val;
      dateI = addDays(dateI, 1);
    }
    return dateI;
  });
  return coveredDates;
};

// looks ahead from the given date to see how months are completely covered for next year
// then generates the status
export const lastRateConfiguredDate = (monthsCovered: Record<string, ServiceMethodParamCalendar[]>) => {
  let dateIterator = new Date();
  let i = 0;
  while (i < 12) {
    if (
      !monthsCovered[format(dateIterator, 'MM/yyyy')] ||
      !monthCompletlyCovered(dateIterator, monthsCovered[format(dateIterator, 'MM/yyyy')])
    ) {
      return dateIterator;
    }
    dateIterator = addMonths(dateIterator, 1);
    i += 1;
  }
  return dateIterator;
};
